import React from 'react'
import Logo from "../assets/Vector (8).svg"
import Facebook from "../assets/facebook.svg"
import Twitter from "../assets/twitter.svg"
import Instagram from "../assets/instagram.svg"
import Linkedin from "../assets/linkedin.svg"
import Trip from "../assets/tripadvisor.svg"
import { Link } from 'react-router-dom'


const Footer = (props) => {
    return (
        <div className='bg-[#FAF8F5] pt-10 pb-10 max-md:pt-0 max-md:pb-5 !mt-20 max-md:!mt-10 max-sm:!mt-5 '>
            <div className="maxwidth  flex flex-col px-5" >
                <div className="w-full max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-wrap max-sm:flex-col max-md:gap-0">
                        <div className="flex flex-col w-[40%] max-md:ml-0 max-md:w-full">
                            <div className="flex max-sm:items-center flex-col max-md:mt-10">
                                <div className='relative'>
                                    <img
                                        loading="lazy"
                                        src={props.logo}
                                        className="aspect-square h-[100px] w-[100px]"
                                        alt='logo'
                                    />
                                    <div className="w-[100px] h-[100px] absolute inset-0 bg-[#FAF8F5] opacity-100 mix-blend-multiply" />

                                </div>
                                <div className="flex flex-grow gap-3 mt-8">
                                    <Link to={`${props.facebook}`} target="_blank">
                                        <img
                                            loading="lazy"
                                            src={Facebook}
                                            alt='instagram'
                                            className="shrink-0 aspect-square w-[42px] max-md:w-[32px] max-sm:w-[22px]"
                                        />
                                    </Link>
                                    <Link to={`${props.instagram}`} target="_blank">
                                        <img
                                            loading="lazy"
                                            src={Instagram}
                                            alt='instagram'
                                            className="shrink-0 aspect-square w-[42px] max-md:w-[32px] max-sm:w-[22px]"
                                        />
                                    </Link>
                                    <Link to={`${props.tripadvisors}`} target="_blank">
                                        <img
                                            loading="lazy"
                                            src={Trip}
                                            alt=' tripadvisor'

                                            className="shrink-0 aspect-square w-[42px] max-md:w-[32px] max-sm:w-[22px]"
                                        />
                                    </Link>
                                    <Link to={`${props.linkedin}`} target="_blank">
                                        <img
                                            loading="lazy"
                                            src={Linkedin}
                                            alt='LinkedIn'

                                            className="shrink-0 aspect-square w-[42px] max-md:w-[32px] max-sm:w-[22px]"
                                        />
                                    </Link>
                                    <Link to={`${props.twitter}`} target="_blank">
                                        <img
                                            loading="lazy"
                                            src={Twitter}
                                            alt='twitter'

                                            className="shrink-0 aspect-square w-[42px] max-md:w-[32px] max-sm:w-[22px]"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col ml-5 w-[26%] max-md:ml-0 max-md:w-[50%]  max-sm:w-full">
                            <div className="flex flex-col grow text-base leading-6 max-md:mt-10 max-sm:mt-5">
                                <div className="card-heading capitalize">
                                    Policies
                                </div>
                                <div className="mt-6 paragraph">Terms & Conditions</div>
                                <div className="mt-4 paragraph">Payment Terms</div>
                                <div className="mt-4 paragraph">Cancellation & Refund Policy</div>
                                <div className="mt-4 paragraph">Cancel Booking</div>
                            </div>
                        </div>
                        <div className="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-[50%]  max-sm:w-full">
                            <div className="flex flex-col text-base leading-6 max-md:mt-10 max-sm:mt-5">
                                <div className="card-heading  capitalize ">
                                    Reach Us At
                                </div>
                                <di className="flex gap-3 mt-6 leading-6">
                                    <img
                                        loading="lazy"
                                        alt="location"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/01a3ebc7fe0aec3ce3a7c2e95724ca9e1bd0b4e16c238f710ea00d23dcb5c8fd?"
                                        className="shrink-0 self-start w-6 aspect-square"
                                    />
                                    <div className='paragraph'>{props.address}</div>
                                </di>
                                <div className="flex gap-2.5 mt-4 whitespace-nowrap">
                                    <img
                                        loading="lazy"
                                        alt="email"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/0231b7a20e6e529b5f7c9245d074719afe8806f960af67361074cfd1c208e0fc?"
                                        className="shrink-0 w-6 aspect-square"
                                    />
                                    <div className='paragraph'>{props.email}</div>
                                </div>
                                <div className="flex gap-3 mt-4">
                                    <img
                                        loading="lazy"
                                        alt="phone"
                                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/2f2d8b1b90c8f2520d8ca76b3f2a28db92e7b9ea809561aca983d2ee1ae7e6bf?"
                                        className="shrink-0 w-6 aspect-square"
                                    />
                                    <div className='paragraph'>{props.phone}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="h-px my-8 bg-[#978667] border-0"></hr>
                <div className="flex gap-5 max-md:gap-2 items-center self-center px-5 max-md:px-0 text-base leading-6 max-md:flex-wrap">
                    <div className='flex items-center gap-2'>
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/610a6346fe7d262723442cbe57fa35a8b48bd473f295fe380c8ab6e02983df06?"
                            className="shrink-0 my-auto w-3 aspect-square fill-zinc-800"
                        />
                        <div className='paragraph'>Copyright Lorium Ipsum</div>
                    </div>
                    <li className='paragraph'>All Rights Reserved</li>
                    <li className='paragraph'>Designed & Developed by <Link to="https://eazotel.com" target='_blank'>Eazotel.com</Link></li>
                </div>
            </div>
        </div>
    )
};

export default Footer;